import { useMemo } from "react";
import { Project } from "../../kronos-kit/entities/project";
import { Task } from "../../kronos-kit/entities/task";
import { Timer } from "../../kronos-kit/entities/timer";
import { User } from "../../kronos-kit/entities/user";
import {
  useGetKronosCurrentTimerQuery,
  useGetKronosProjectsQuery,
  useGetKronosTasksQuery,
  useGetKronosTimersQuery,
  useGetKronosUsersQuery,
} from "./kronosEndpoints";

export function useKronosProjects(args?: Record<string, unknown>) {
  const query = useGetKronosProjectsQuery(args);

  return useMemo(() => {
    const projects = (query.data ?? []).map((project) => new Project(project));
    const projectsMap: { [id: number]: Project } = {};
    projects.forEach((project) => {
      projectsMap[project.id] = project;
    });

    return {
      ...query,
      projects,
      projectsMap,
    };
  }, [query]);
}

export function useKronosTasks(args?: Record<string, unknown>) {
  const query = useGetKronosTasksQuery(args);

  return useMemo(() => {
    const tasks = (query.data ?? []).map((task) => new Task(task));
    const tasksMap: { [id: number]: Task } = {};
    tasks.forEach((task) => {
      tasksMap[task.id] = task;
    });

    return {
      ...query,
      tasks,
      tasksMap,
    };
  }, [query]);
}

export function useKronosUsers(args?: Record<string, unknown>) {
  const query = useGetKronosUsersQuery(args);

  return useMemo(() => {
    const users = (query.data ?? []).map((user) => new User(user));
    const usersMap: { [id: number]: User } = {};
    users.forEach((user) => {
      usersMap[user.id] = user;
    });

    return {
      ...query,
      users,
      usersMap,
    };
  }, [query]);
}

export function useKronosTimers(args?: Record<string, unknown>) {
  const query = useGetKronosTimersQuery(args);

  return useMemo(() => {
    const timers = (query.data ?? [])
      .map((timer) => new Timer(timer))
      .sort((a, b) => b.id - a.id);
    const timersMap: { [id: number]: Timer } = {};
    timers.forEach((timer) => {
      timersMap[timer.id] = timer;
    });

    return {
      ...query,
      timers,
      timersMap,
    };
  }, [query]);
}

export function useKronosCurrentTimer() {
  const query = useGetKronosCurrentTimerQuery();

  return useMemo(() => {
    return {
      ...query,
      currentTimer: query.data ? new Timer(query.data) : undefined,
    };
  }, [query]);
}
